import { useLayoutEffect, useState, useRef, useEffect } from 'react';

export function useMatchMedia(media: string) {
    const [queryMatch, setQueryMatch] = useState(false);
    useLayoutEffect(() => {
        if (window && window.matchMedia) {
            const mediaQueryList = window.matchMedia(media);
            const setQuery = () => setQueryMatch(mediaQueryList.matches);
            setQuery();
            mediaQueryList.addEventListener('change', setQuery);

            return () => {
                mediaQueryList.removeEventListener('change', setQuery);
            };
        }
    }, [media]);

    return queryMatch;
}
export const useSkipFirstRender = (dep: boolean) => {
    const [firstRender, setFirstRender] = useState(true);
    const isMounted = useRef(false);

    useEffect(() => {
        if (isMounted.current) {
            return () => setFirstRender(false);
        }
    }, [dep]);

    useEffect(() => {
        isMounted.current = true;
    }, []);
    return firstRender;
};
